import { render, staticRenderFns } from "./channel-additional-information.vue?vue&type=template&id=18cf2185"
import script from "./channel-additional-information.vue?vue&type=script&lang=js"
export * from "./channel-additional-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports